import { BehaviorSubject, Subject } from "rxjs";

class EntityManager {
  constructor(world) {
    this.world = world;

    this.entity$ = new Subject();
    this.entities = {};
    this.entities$ = {};
  }

  getEntity(id) {
    return this.entities[id];
  }

  setEntity(id, entity) {
    this.entities[id] = entity;
    const entity$ = this.getEntity$(id);
    if (entity) {
      entity$.next(entity);
      this.entity$.next(entity)     
    } else {
      delete this.entityDefinitions[id];
      this.completeEntityDefinition$(id);
    }
  }

  patchEntity(id, entity) {
    this.setEntity(id, { ...this.getEntity(id), ...entity });
  }

  getEntity$(id) {
    if (!this.entities$[id]) {
      this.entities$[id] = new BehaviorSubject();
    }
    return this.entities$[id];
  }

  completeEntity$(id) {
    if (!this.entities$[id]) {
      this.entities$[id].complete();
      delete this.entities$[id];
    }
  }
}

export default EntityManager;
